import React from "react";

export default function Web_CSS_Icons() {
  return (
    <div>
      <h1>What is CSS Icons</h1>
      <p>
        Route: <code>/web/css-icons</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
